import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstUnit = createSlice({
    name: "getAllMstUnit",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstUnit_actions = getAllMstUnit.actions;
export var fetchData = _getAllMstUnit_actions.fetchData, fetchDataSuccess = _getAllMstUnit_actions.fetchDataSuccess, fetchDataFailure = _getAllMstUnit_actions.fetchDataFailure, resetState = _getAllMstUnit_actions.resetState;
export default getAllMstUnit.reducer;
